import * as S from './style';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
//Icons
import { Eye, EyeSlash } from "@phosphor-icons/react";
//components
import LayoutModal from '../../../../../components/LayoutModal';
//hooks
import useLoading from '../../../../../hooks/useLoading';
import apiRequest from '../../../../../hooks/apiRequest';
import { usePasswordToggle } from '../../../../../hooks/usePasswordToggle';
import { IUser } from 'Interfaces/IUser';

interface Inputs {
    email: string;
    password: string;

    user: IUser
}

interface ICreate {
    isOpenModalAuth: boolean;
    setModalClose: () => void;
    onAuthSuccess: (userId: number) => void;
}
export default function AuthPromotion({
    isOpenModalAuth,
    setModalClose,
    onAuthSuccess
}: ICreate) {
    const {
        register,
        control,
        reset,
        handleSubmit: handleFormSubmit,
        formState: { errors },
    } = useForm<Inputs>();
    const { isLoading, startLoading, stopLoading } = useLoading();
    const { inputType, icon, togglePasswordVisibility } = usePasswordToggle();

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        startLoading();
        try {
            const response = await apiRequest<Inputs>('auth', 'POST', { ...data });
            if (response.status === 200) {
                const userId = response.data.user.id;
                onAuthSuccess(userId);
            }
        } catch (error: any) {
            alert(error.message || "Ocorreu um erro ao criar o usuário.");
        } finally {
            stopLoading();
        }
    };

    const onClose = () => {
        reset();
        setModalClose();
    }

    if (!isOpenModalAuth) {
        return null;
    }
    return (
        <LayoutModal
            statusLoad={isLoading}
            title="Autorização de Promoção"
            subTitle="Informe o e-mail e senha para prosseguir com o desconto."
            setModalClose={onClose}
            submiteModal={handleFormSubmit(onSubmit)}
        >
            <S.Content>
                <S.FormInput>
                    <S.Label>
                        E-mail
                        <span>*</span>
                    </S.Label>
                    <S.Input
                        placeholder="Informe o e-mail"
                        type="email"
                        {...register("email", { required: true })}
                    />
                    {errors.email && (
                        <S.InforErro>Campo Obrigatório</S.InforErro>
                    )}
                </S.FormInput>

                <S.FormInput>
                    <S.Label>
                        Senha
                        <span>*</span>
                    </S.Label>
                    <S.ContentInput>
                        <S.InputUnstyled
                            {...register("password", { required: true })}
                            type={inputType}
                            placeholder="Informe sua senha"
                        />

                        <S.ButtonOpenPassword type="button" onClick={togglePasswordVisibility}>
                            {icon === "eye-open" ? (
                                <Eye size={20} />
                            ) : (
                                <EyeSlash size={20} />
                            )}
                        </S.ButtonOpenPassword>
                    </S.ContentInput>
                    {errors.password && (
                        <S.InforErro>Campo Obrigatório</S.InforErro>
                    )}
                </S.FormInput>
            </S.Content>
        </LayoutModal>
    )
}
